import React, { useEffect, useState } from "react";
import "./Reward.css";
import Blue_Round_Btn from "../../../common-components/common-btn/blue_round_btn/Blue_Round_Btn";
import { Dropdown, DropdownButton, Form } from "react-bootstrap";
import Pagination_Holder from "../../../common-components/pagination_holder/Pagination_Holder";
import Success_Modal from "../../../common-components/common-modals/success_modal/Success_Modal";
import { useDispatch, useSelector } from "react-redux";
import { getAllWalletHistory } from "../../../../features/wallet/walletSlice";
import { formatDate } from "../../../../utils/common";
import { AiOutlineGift } from "react-icons/ai";
import Red_Outline_Btn from "../../../common-components/common-btn/red_outline_btn/Red_Outline_Btn";
import Gray_Outline_Button from "../../../common-components/common-btn/gray_outline_btn/Gray_Outline_Button";
const Reward = () => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);

  const data = [
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },

    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
    {
      purchase: "₹4,495",
      date: "25-06-2025",
      type: "Purchase",
      reward_amount: "₹495",
    },
  ];

  const itemsPerPage = 5;

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const perPage = 10;

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const [selected, setSelected] = useState("");

  const options = [
    "Purchase",
    "Referral",
    "Last Week",
    "Last Month",
    "Last Year",
  ];

  const dispatch = useDispatch();
  const wallet = useSelector((state) => state.wallet.allWalletHistory);
  const { startDate, endDate } = getDateRange(selected);
  // useEffect(() => {
  //   dispatch(getAllWalletHistory({ page: currentPage, type: selected }));
  // }, [dispatch, currentPage, selected]);

  useEffect(() => {
    const { startDate, endDate } = getDateRange(selected);

    dispatch(
      getAllWalletHistory({
        page: currentPage,
        type: selected,
        startDate,
        endDate,
      })
    );
  }, [dispatch, currentPage, selected]);

  useEffect(() => {
    setCurrentPage(wallet?.current_page);
    setTotalPages(wallet?.total_pages);
  }, [wallet]);

  function getDateRange(option) {
    const now = new Date();

    switch (option) {
      case "Last Week":
        const lastWeekStart = new Date();
        lastWeekStart.setDate(now.getDate() - 7);
        return {
          startDate: lastWeekStart.toISOString(),
          endDate: now.toISOString(),
        };

      case "Last Month":
        const lastMonthStart = new Date();
        lastMonthStart.setMonth(now.getMonth() - 1);
        return {
          startDate: lastMonthStart.toISOString(),
          endDate: now.toISOString(),
        };

      case "Last Year":
        const lastYearStart = new Date();
        lastYearStart.setFullYear(now.getFullYear() - 1);
        return {
          startDate: lastYearStart.toISOString(),
          endDate: now.toISOString(),
        };

      default:
        return {};
    }
  }

  const handlePageReset = () => {
    setSelected("");
  };
  return (
    <section className="Reward">
      <div className="reward_card">
        <div className="yellow_div">
          <div className="left_side">
            <img
              src="/assets/images/my_account/reward/reward_img.png"
              className="reward_img"
            />
            <span className="inner_text">Rewards</span>
          </div>
          <div className="right_side">
            <p className="white_text">Total Earning</p>
            <p className="rupee_text">
              ₹{Number(wallet?.user_wallet?.amount).toFixed(2)}
            </p>
          </div>
        </div>

        {/* <div className="gray_div">
          <div className="btn_holder">
            <Blue_Round_Btn btnText={"Withdraw now"} onClick={() => {setShowSucsessModal(true)}}/>
          </div>
        </div> */}
      </div>

      <>
        <div className="bottom_div">
          <div className="filter_outer_div">
            <p className="title_text">Rewards History</p>
            <div className="filter_inner_div">
              <DropdownButton
                id="dropdown-filter"
                title={selected || "Filter"}
                className="custom-dropdown"
              >
                {options.map((item, idx) => (
                  <Dropdown.Item
                    as="button"
                    key={idx}
                    onClick={() => {
                      setSelected(item);
                      setCurrentPage(1);
                    }}
                    className={`dropdown-radio-item ${
                      selected === item ? "active" : ""
                    }`}
                  >
                    <div className="radio-option">
                      <input
                        type="radio"
                        name="filter"
                        checked={selected === item}
                        readOnly
                      />
                      <label>{item}</label>
                    </div>
                  </Dropdown.Item>
                ))}
              </DropdownButton>

              <div className="reset_btn">
                <Red_Outline_Btn btnText="Reset" onClick={handlePageReset} />
              </div>
            </div>
          </div>
          {wallet?.data?.length > 0 ? (
            <div className="common_table_container theme_bg">
              <div className="table-responsive">
                <table className="common_table table">
                  <thead>
                    <tr>
                      <th>Purchase Amount</th>
                      <th>Date</th>
                      <th>Type</th>
                      <th>Reward Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {wallet.data.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.purchase_amount}</td>
                        <td>{formatDate(item.createdAt)}</td>
                        <td>{item.Transaction_Type?.name}</td>
                        <td>{Number(item.amount).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className="empty-state text-center my-5">
              <AiOutlineGift
                size={80}
                color="#888"
                style={{ marginBottom: "20px" }}
              />
              <h5>No reward transactions yet</h5>
              <p>Your rewards will appear here once available.</p>
            </div>
          )}
        </div>

        <div className="comon_page_footer">
          <div className="pagination_div">
            <Pagination_Holder
              onPageChange={currentPage}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="AMOUNT WITHDRAW SUCCESSFULLY!"
      />
    </section>
  );
};

export default Reward;
